const basePath = '/document-templates';

// Start Template
export const startPathSlug = 'start';

// Prepare Template
export const preparePathSlug = 'prepare';

// Review And Save Template
export const reviewPathSlug = 'review';

export const DocgenRequestWithTemplateRIDRouteRegex =
	/\/document-templates\/(.*?)\/details/;

// Template dashboard
export const templatesPiletDashboardPath = '/templates';

// Default Redirect Path
export const defaultRedirectPath = '/dashboard';

// Template details
const templateDetailsSlug = 'details';
export const templateDetailsPath = basePath + '/:templateRID/' + templateDetailsSlug;
export const templateDetailsRoutePath = basePath + '/*/' + templateDetailsSlug;

// Signature request from template
const templateSignatureRequestSlug = 'signature-request';
export const templateSignatureRequestPath =
	basePath + '/:documentRID/' + templateSignatureRequestSlug;
export const templateSignatureRequestRoutePath =
	basePath + '/*/' + templateSignatureRequestSlug;

// E-sign pilet: Signature details path
const signaturerequestsBasePath = '/signaturerequests';
const signatureRequestDetailsSlug = 'details';
export const signatureRequestDetailsPath =
	signaturerequestsBasePath + '/:signatureRequestID/' + signatureRequestDetailsSlug;

// E-sign pilet: Create Signature request path
const signatureRequestCreateSlug = 'create';
export const signatureRequestCreatePath =
	signaturerequestsBasePath + '/' + signatureRequestCreateSlug;

export const signatureRequestDashboardPath =
	signaturerequestsBasePath.substring(1) + '/dashboard';
